<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="black" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.2559 4.41075C17.5814 4.73618 17.5814 5.26382 17.2559 5.58926L8.08926 14.7559C7.76382 15.0814 7.23618 15.0814 6.91074 14.7559L2.74408 10.5893C2.41864 10.2638 2.41864 9.73618 2.74408 9.41075C3.06951 9.08531 3.59715 9.08531 3.92259 9.41075L7.5 12.9882L16.0774 4.41075C16.4028 4.08531 16.9305 4.08531 17.2559 4.41075Z"
    />
  </svg>
</template>
